import React, {useContext} from 'react';

import {OrderContext} from 'views/order/OrderForm';
import {Input, Checkbox} from 'views/FormElements';

const CouponCodeInput = () => {
    const {values} = useContext(OrderContext);

    return <React.Fragment>
            <div id="couponCodeDiv">
                <div className="flexRow">
                    <Checkbox name="hasCouponCode" label="I have a Coupon Code!" />
                </div>

                {
                    values.hasCouponCode &&
                    <div>
                        <Input style={{flexGrow: '1'}} name="couponCode" type="text" placeholder="Enter Coupon Code"/>
                    </div>
                }
            </div>
    </React.Fragment>
};

export default CouponCodeInput;


// WEBPACK FOOTER //
// ./src/views/order/input/CouponCodeInput.js